var SBTDSearch = function(elementId, options) {
  	
  this.el = null;
  this.box = null;
  this.val = '';
  this.timer = null;
  
  this.options = {
    keyTypeInterval: 50,
    searchOnMinChars: 1
  };
  
  this.init = function(elementId, options) {
    this.el = $('#' + elementId);
  	if (this.el.length == 0) {
    	console.log('no search field');
    	return;
  	}
    
    this.box = $('<div class="sbtd-search-dropdown-menu"></div>');
    this.box.insertAfter(this.el);
    this.box = this.el.next();
    
    this.options = $.extend({}, this.options, options || {});
  
  	this.el.on('keyup', this.searchAction.bind(this));
    //this.el.on('blur', this.hideBox.bind(this));
    this.el.on('focus', this.displayBox.bind(this));
    // this.search = $('.sbtd-search-show-results');
    // this.search.on('click', this.dataSave.bind(this));
    
    $(window).on('click', this.clickAwayCheck.bind(this));

  };
  
  this.clickAwayCheck = function(event) {
    var target = $(event.target);
    var elId = this.el.attr('id');
    
    if (target.parents(elId).length == 0) {
      if (target.attr('id') != elId) {
        this.hideBox();
      }      
    }
  };
  
  this.displayBox = function() {
    this.box.css('display', 'block');
  };
  
  this.hideBox =  function() {
    this.box.css('display', 'none');
  },
  this.emptyBox =  function() {
    this.box.html('');
  },
  
  this.searchAction = function(event) {
    var val = this.el.val().trim();
    
    if (val == '') {
      this.emptyBox();
    }

    if (event.which == 38 || event.which == 40 || event.which == 13) {
      if (event.which == 40) {
        var first = false;
        this.box.find('.sbtd-search-entry').each(function() {
          let item = $(this);
          if (item.attr('data-select') == 'yes') {
            item.css('background-color', 'white');
            item.attr('data-select', 'no');
            item.next('.sbtd-search-entry').css('background-color', 'hotpink');
            item.next('.sbtd-search-entry').attr('data-select', 'yes');
            first = true;
            return false;
          };
        });
        if (first == false) {
        	this.box.find('.sbtd-search-entry').first().css('background-color', 'hotpink');
          	this.box.find('.sbtd-search-entry').first().attr('data-select', 'yes');
        }
      } else if (event.which == 38) {
        var last = false;
        this.box.find('.sbtd-search-entry').each(function() {
          let item = $(this);
          if (item.attr('data-select') == 'yes') {
            item.css('background-color', 'white');
            item.attr('data-select', 'no');
            item.prev('.sbtd-search-entry').css('background-color', 'hotpink');
            item.prev('.sbtd-search-entry').attr('data-select', 'yes');
            last = true;
            return false;
          };
        })
        if (last == false) {
        	this.box.find('.sbtd-search-entry').last().css('background-color', 'hotpink');
          	this.box.find('.sbtd-search-entry').last().attr('data-select', 'yes');
        }

      } else if (event.which == 13) {
        var select = false;
        this.box.find('.sbtd-search-entry').each(function(index, el) {
          var el = $(el);
          if (el.attr('data-select') == 'yes') {
            select = true;
            var link = '/products/' + el.attr('data-handle');
            var dataObj = {
              product_id: el.attr('data-id'),
              search_term: val 
            };
            jQuery.ajax({
              crossDomain: true,
              type: 'POST',
              method: 'POST',
              url: "https://app.savedbythedress.net/shopify/quick/searchSave",
              data: dataObj
            })
            .done(function(response) {
               window.location.href = link;
            }).fail(function(obj) {
               window.location.href = link;
            });
          }
        }.bind(this))
        if (select == false) {
          this.dataSave();
          return false;
        }

      } 
    } else{
      this.val = this.el.val();
      if (this.val.length >= this.options.searchOnMinChars) {

        //reset the timer if not fired yet
        if(this.timer != null) {
          clearTimeout(this.timer);

        }
        this.timer = setTimeout(this.getResults.bind(this), this.options.keyTypeInterval);

      }
    }
  };
    
  this.dataSave = function() {
    var val = this.val;
    var dataObj = {
      product_id: null,
      search_term: val
    };
    jQuery.ajax({
      crossDomain: true,
      type: 'POST',
      method: 'POST',
      url: "https://app.savedbythedress.net/shopify/quick/searchSave",
      data: dataObj
    })
    .done(function(response) {
      	//showAllTemplate();
      document.location.href = "/pages/search-results?s=" + val;
    }).fail(function(obj) {
      // alert;
    });
    return false;
    
  };
  
  this.getResults = function() {
    jQuery.ajax({
      	crossDomain: true,
  		url: "https://app.savedbythedress.net/shopify/quick/search?quick=true&search=" + this.val
	}).done(this.successCallback.bind(this));
    
  };
  
  this.successCallback = function(response) {
    this.displayBox();
    this.emptyBox();
    if (response.errors == true) {
      this.errorAction(response.data.message);
    }
    var products = response.data.products;
    
    if (products.length > 0) {
      this.displayProducts(products);
      this.displayAllProductsLink();
    } else {
      this.displayNoProducts();
    }
    
  };
  
  this.assignClickEvents = function() {
    var val = this.val;
    
  	this.box.find('.sbtd-search-entry').on('click', function() {
    	var el = $(this);
      	var link = '/products/' + el.attr('data-handle');
      	var dataObj = {
        	product_id: el.attr('data-id'),
        	search_term: val 
      	};
      	jQuery.ajax({
      		crossDomain: true,
          	method: 'post',
          	type: 'post',
  			url: "https://app.savedbythedress.net/shopify/quick/searchSave",
			data: dataObj,
		})
        .done(function(response) {
          window.location.href = link;
        }).fail(function(obj) {
          window.location.href = link;
        });
      		
    });
    
   
  };
  
  this.errorAction = function(msg) {
    this.box.html(this.errorTempate(msg));
  };
  
  this.displayAllProductsLink = function() {
    this.box.append(this.showAllTemplate());
    
    this.box.find('.sbtd-search-show-results').on('click', this.dataSave.bind(this));
  };
  
  this.displayProducts = function(prods) {
    
    $.each(prods, function(index, el) {
      this.box.append(this.productTemplate(el));
    }.bind(this));
    
    this.assignClickEvents();
  };
  
  this.displayNoProducts = function() {
    this.box.html(this.noProductsTemplate());
  };
  
  this.showAllTemplate =  function() {
    var link = "/pages/search-results?s=" + this.val;
    return `<div class="sbtd-search-show-results" style="border-bottom: solid 1px #d8d8d8; line-height: 50px;"><a style="color: hotpink;" href="${link}">Show All Results</a></div>`;
  };
  
  this.productTemplate = function(prod) {
    var hide_class = "";
    var center_class = "";
    prod.title == "Gift Card" ? hide_class = "sbtd-search-hidden" : hide_class = "";
    prod.title == "Gift Card" ? center_class = "sbtd-search-center" : center_class = "";
    var price = '$ ' + prod.price.toFixed(2);
    var img = prod.images.replace('.jpg', '_thumb.jpg');
    var link = "/products/" + prod.handle;
    return `
<div class="sbtd-search-entry" style="border-bottom: 1px solid rgb(217, 217, 212); white-space: normal;" data-id="${prod.id}" data-handle="${prod.handle}"">
<a href="javascript:void();" title="Open ${prod.title}">
<div class="sbtd-search-img-container"><img class="sbtd-search-img" src="${img}"></div>
    <div class="sbtd-search-product-section">
<div class="sbtd-search-item-name ${center_class}">
${prod.title}
      </div>
<div class="sbtd-search-item-price ${hide_class}">${price}</div>
    </div>
</a>
  </div>
`;
  };
  
  this.noProductsTemplate = function() {
    return `<div class="sbtd-search-no-products">No products found, please refine your search</div>`;
  };
  
  this.errorTemplate = function(msg) {
    return `<div class="sbtd-search-error">${msg}</div>`;
  };
  this.init(elementId, options);
};

jQuery(document).ready(function() {
  
  var siteSearch = new SBTDSearch('theTopSearch');
  var mobileSearch = new SBTDSearch('theMobileSearch');
  
  $('.show-search').click(function() {
    $('.shifter-handle').click();
    $('#theMobileSearch').focus();
    return false;
  });
  
});
